import { jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { clearToken, loadToken, saveToken, setOnUnauthorized } from './api/client';
import { requestCode as apiRequestCode, verifyCode as apiVerifyCode } from './api';
const Ctx = createContext(null);
export function AuthProvider({ children }) {
    const [status, setStatus] = useState('checking');
    const [email, setEmail] = useState(null);
    useEffect(() => {
        const t = loadToken();
        setStatus(t ? 'authed' : 'anon');
        setOnUnauthorized(() => {
            setStatus('anon');
            setEmail(null);
        });
        return () => setOnUnauthorized(null);
    }, []);
    const requestCode = useCallback(async (e) => {
        await apiRequestCode(e);
        setEmail(e);
    }, []);
    const verifyCode = useCallback(async (e, c) => {
        const res = await apiVerifyCode(e, c);
        saveToken(res.token);
        setStatus('authed');
        setEmail(res.user.email);
    }, []);
    const logout = useCallback(() => {
        clearToken();
        setStatus('anon');
        setEmail(null);
    }, []);
    const value = useMemo(() => ({ status, email, requestCode, verifyCode, logout }), [status, email, requestCode, verifyCode, logout]);
    return _jsx(Ctx.Provider, { value: value, children: children });
}
export function useAuth() {
    const ctx = useContext(Ctx);
    if (!ctx)
        throw new Error('useAuth must be inside <AuthProvider>');
    return ctx;
}
